import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private _httpService: HttpService) { }

  // 
  /**
   * Add Feedback
   */
  updateProfile(data) {

    return new Promise((resolve, reject) => {
      this._httpService.post('ProfileUpdate', data).subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data)
        }
        else {
          reject(data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }

  // Select Rank
  getRanks() {
    return new Promise((resolve, reject) => {
      this._httpService.get('getRanksData').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }
  // Select  Standard
  getSchoolStandard() {
    return new Promise((resolve, reject) => {
      this._httpService.get('getstdData').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }
  // Select  Standard
  getSudentDetails() {
    return new Promise((resolve, reject) => {
      this._httpService.get('getstudentData').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }
  // Select  Standard
  getSchool() {
    return new Promise((resolve, reject) => {
      this._httpService.get('getschoolName').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }

  getenquirycount(){
    return new Promise((resolve, reject) => {
      this._httpService.get('getenquirycount').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }
  getStudentcount(){
    return new Promise((resolve, reject) => {
      this._httpService.get('getstudentcounts').subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }
  

}
